<!-- 受邀列表 -->
<template>
  <div class="home">
    <van-nav-bar title="受邀面试" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 列表项 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <!-- 推荐企业 -->
        <div>
          <div
            class="company-list"
            v-for="(item, index) in list"
            :key="index"
            @click="navDetails(item.company_id)"
          >
            <img class="company-img" :src="item.logo" />
            <div class="company-box">
              <span class="name">{{item.name}}</span>
              <div class="icon">
                <span class="item">{{item.address}} ∣ {{item.nature_name}} ∣ {{item.trade_name}}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { JobInvite } from "@/api/apiData";
export default {
  components: {},
  data() {
    return {
      page: 0,
      totalPages: 1,
      list: [],
      offset: 10,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.back();
    },
    getList() {
      const that = this;
      let { page, totalPages, list, offset } = that;
      let obj = {
        page: page + 1,
        offset: offset
      };
      if (totalPages > page) {
        that.loading = true;
        JobInvite(obj).then(res => {
          //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data);
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            that.page = page + 1;
            if (res.data.length == 0) {
              setTimeout(() => {
                that.loading = false;
                that.finished = true;
              }, 1500);
              return false;
            }
            if (that.list.length > list.length) {
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          }
        });
      } else {
        that.finished = true;
        that.loading = false;
      }
    },
        // 查看公司详情
    navDetails(id) {
      const that = this;
      that.$router.push({
        name: "ComponyDetails",
        query: {
          id: id
        }
      });
    },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0;

      that.list = [];
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    }
  },
  created() {},
  mounted() {
      this.getList();
  }
};
</script>
<style lang='less' scoped>
.company-list {
  background: #fff;
  padding: 0.24rem 0.32rem;
  margin-top: 0.2rem;
  font-size: 0.3rem;
  display: flex;
  .company-img {
    width: 1.2rem;
    height: 1.2rem;
  }
  .company-box {
    margin-left: 0.3rem;
    position: relative;
    width: 80%;
    .name {
      font-size: 0.34rem;
      font-weight: bold;
      line-height: 1.5;
      color: #333333;
      display: block;
      margin-bottom: 0.14rem;
    }
    .icon {
      display: flex;
      align-items: center;
      font-size: 0.22rem;
      color: #8f8f8f;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>